<div class="min-h-screen bg-gray-50 py-8">
    <div class="max-w-7xl mx-auto px-4">
        <!-- Header -->
        <div class="mb-6">
            <div class="flex items-center text-sm text-gray-600 mb-2">
                <a routerLink="/console/parametros-sistema" class="hover:text-blue-600">
                    <i class="fas fa-arrow-left mr-2"></i>
                    Parámetros del Sistema
                </a>
            </div>
            <h1 class="text-3xl font-bold text-gray-900">Configuración de Aplicación Móvil</h1>
            <p class="text-gray-600 mt-1">Administra servicios disponibles y configuraciones de la aplicación móvil</p>
        </div>

        <!-- Tab Navigation -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
            <div class="border-b border-gray-200">
                <nav class="flex -mb-px">
                    <button (click)="changeTab('services')" [class.border-blue-500]="activeTab === 'services'"
                        [class.text-blue-600]="activeTab === 'services'"
                        [class.border-transparent]="activeTab !== 'services'"
                        [class.text-gray-500]="activeTab !== 'services'"
                        class="flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors focus:outline-none">
                        <i class="fas fa-list mr-2"></i>
                        Servicios Disponibles
                    </button>
                    <button (click)="changeTab('simon')" [class.border-blue-500]="activeTab === 'simon'"
                        [class.text-blue-600]="activeTab === 'simon'" [class.border-transparent]="activeTab !== 'simon'"
                        [class.text-gray-500]="activeTab !== 'simon'"
                        class="flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors focus:outline-none">
                        <i class="fas fa-comments mr-2"></i>
                        Configuración SIMON
                    </button>
                    <button (click)="changeTab('register')" [class.border-blue-500]="activeTab === 'register'"
                        [class.text-blue-600]="activeTab === 'register'"
                        [class.border-transparent]="activeTab !== 'register'"
                        [class.text-gray-500]="activeTab !== 'register'"
                        class="flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors focus:outline-none">
                        <i class="fas fa-user-plus mr-2"></i>
                        Registro
                    </button>
                    <button (click)="changeTab('carrusel')" [class.border-blue-500]="activeTab === 'carrusel'"
                        [class.text-blue-600]="activeTab === 'carrusel'"
                        [class.border-transparent]="activeTab !== 'carrusel'"
                        [class.text-gray-500]="activeTab !== 'carrusel'"
                        class="flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors focus:outline-none">
                        <i class="fas fa-images mr-2"></i>
                        Carrusel
                    </button>
                    <button (click)="changeTab('homeModal')" [class.border-blue-500]="activeTab === 'homeModal'"
                        [class.text-blue-600]="activeTab === 'homeModal'"
                        [class.border-transparent]="activeTab !== 'homeModal'"
                        [class.text-gray-500]="activeTab !== 'homeModal'"
                        class="flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors focus:outline-none">
                        <i class="fas fa-window-restore mr-2"></i>
                        Modal Home App
                    </button>
                </nav>
            </div>

            <!-- Tab Content -->
            <div class="p-6">
                <!-- Services Tab -->
                <div *ngIf="activeTab === 'services'">
                    <div class="flex justify-between items-center mb-6">
                        <h2 class="text-xl font-semibold text-gray-900">Servicios Disponibles en la App</h2>
                        <button *ngIf="_auth.hasPermission('config.app_movil.create')" (click)="openAddServiceModal()"
                            class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                            <i class="fas fa-plus mr-2"></i>
                            Agregar Servicio
                        </button>
                    </div>

                    <!-- Loading State -->
                    <div *ngIf="servicesLoading" class="text-center py-12">
                        <i class="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
                        <p class="text-gray-600">Cargando servicios...</p>
                    </div>

                    <!-- Services List -->
                    <div *ngIf="!servicesLoading && rootServices.length > 0" class="space-y-3">
                        <div *ngFor="let service of rootServices" class="space-y-2">
                            <!-- Parent Service -->
                            <div
                                class="bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-blue-300 transition-colors">
                                <div class="flex items-center justify-between">
                                    <div class="flex-1">
                                        <h3 class="text-lg font-semibold text-gray-900">{{ service.name || service.code
                                            }}
                                        </h3>
                                        <p class="text-sm text-gray-600 mt-1" *ngIf="service.description">{{
                                            service.description }}</p>
                                        <p class="text-xs text-gray-500 mt-1">
                                            <span class="font-mono bg-gray-200 px-2 py-1 rounded">{{ service.code
                                                }}</span>
                                        </p>
                                    </div>
                                    <div class="flex items-center space-x-4">
                                        <!-- Toggle Switch -->
                                        <label class="relative inline-flex items-center cursor-pointer">
                                            <input type="checkbox" [checked]="service.enabled"
                                                (change)="toggleService(service, $event)" [disabled]="service.loading || !_auth.hasPermission('config.app_movil.config')"
                                                class="sr-only peer" />
                                            <div
                                                class="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
                                            </div>
                                            <span class="ml-3 text-sm font-medium text-gray-700">
                                                {{ service.enabled ? 'Activo' : 'Inactivo' }}
                                            </span>
                                        </label>

                                        <!-- Delete Button -->
                                        <button *ngIf="_auth.hasPermission('config.app_movil.delete')" (click)="deleteService(service)" [disabled]="service.deleting"
                                            class="text-red-600 hover:text-red-800 hover:bg-red-50 p-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-red-500"
                                            title="Eliminar servicio">
                                            <i class="fas" [class.fa-spinner]="service.deleting"
                                                [class.fa-spin]="service.deleting"
                                                [class.fa-trash]="!service.deleting"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Child Services -->
                            <div *ngIf="service.children && service.children.length > 0"
                                class="ml-8 space-y-2 border-l-2 border-gray-200 pl-4">
                                <div *ngFor="let child of service.children"
                                    class="bg-white rounded-lg border border-gray-200 p-3 hover:border-blue-300 transition-colors">
                                    <div class="flex items-center justify-between">
                                        <div class="flex-1">
                                            <div class="flex items-center">
                                                <i class="fas fa-level-up-alt fa-rotate-90 text-gray-400 mr-2"></i>
                                                <h4 class="text-md font-medium text-gray-900">{{ child.name ||
                                                    child.code }}</h4>
                                            </div>
                                            <p class="text-xs text-gray-600 mt-1 ml-6" *ngIf="child.description">{{
                                                child.description }}</p>
                                            <p class="text-xs text-gray-500 mt-1 ml-6">
                                                <span class="font-mono bg-gray-100 px-2 py-0.5 rounded">{{ child.code
                                                    }}</span>
                                            </p>
                                        </div>
                                        <div class="flex items-center space-x-4">
                                            <!-- Toggle Switch -->
                                            <label class="relative inline-flex items-center cursor-pointer">
                                                <input type="checkbox" [checked]="child.enabled"
                                                    (change)="toggleService(child, $event)" [disabled]="child.loading || !_auth.hasPermission('config.app_movil.config')"
                                                    class="sr-only peer" />
                                                <div
                                                    class="w-9 h-5 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600">
                                                </div>
                                            </label>

                                            <!-- Delete Button -->
                                            <button *ngIf="_auth.hasPermission('config.app_movil.delete')" (click)="deleteService(child)" [disabled]="child.deleting"
                                                class="text-red-600 hover:text-red-800 hover:bg-red-50 p-1.5 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-red-500"
                                                title="Eliminar servicio">
                                                <i class="fas fa-sm" [class.fa-spinner]="child.deleting"
                                                    [class.fa-spin]="child.deleting"
                                                    [class.fa-trash]="!child.deleting"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Empty State -->
                    <div *ngIf="!servicesLoading && services.length === 0" class="text-center py-12">
                        <i class="fas fa-inbox text-6xl text-gray-300 mb-4"></i>
                        <p class="text-gray-600 text-lg mb-2">No hay servicios configurados</p>
                        <p class="text-gray-500 text-sm">Agrega un servicio para comenzar</p>
                    </div>
                </div>

                <!-- SIMON Tab -->
                <div *ngIf="activeTab === 'simon'">
                    <h2 class="text-xl font-semibold text-gray-900 mb-6">Configuración de SIMON Chat</h2>

                    <!-- Loading State -->
                    <div *ngIf="simonLoading" class="text-center py-12">
                        <i class="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
                        <p class="text-gray-600">Cargando configuración...</p>
                    </div>

                    <!-- SIMON Configuration -->
                    <div *ngIf="!simonLoading" class="bg-gray-50 rounded-lg border border-gray-200 p-6">
                        <div class="flex items-center justify-between">
                            <div class="flex-1">
                                <h3 class="text-lg font-semibold text-gray-900 mb-2">
                                    <i class="fas fa-comments text-blue-600 mr-2"></i>
                                    Mostrar SIMON Chat en la App
                                </h3>
                                <p class="text-sm text-gray-600">
                                    Controla si el chat de SIMON está visible para los usuarios en la aplicación móvil
                                </p>
                            </div>
                            <div class="ml-6">
                                <label class="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" [checked]="showSimon" (change)="onSimonToggleChange($event)"
                                        [disabled]="simonToggleLoading || !_auth.hasPermission('config.app_movil.config')" class="sr-only peer" />
                                    <div
                                        class="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600">
                                    </div>
                                    <span class="ml-3 text-sm font-medium" [class.text-green-600]="showSimon"
                                        [class.text-gray-500]="!showSimon">
                                        {{ showSimon ? 'Activado' : 'Desactivado' }}
                                    </span>
                                </label>
                            </div>
                        </div>

                        <!-- Status Indicator -->
                        <div class="mt-4 pt-4 border-t border-gray-200">
                            <div class="flex items-center">
                                <div class="flex-shrink-0">
                                    <div class="h-3 w-3 rounded-full" [class.bg-green-500]="showSimon"
                                        [class.bg-gray-400]="!showSimon"></div>
                                </div>
                                <p class="ml-3 text-sm text-gray-600">
                                    Estado actual:
                                    <span class="font-semibold" [class.text-green-600]="showSimon"
                                        [class.text-gray-600]="!showSimon">
                                        {{ showSimon ? 'Los usuarios pueden ver el chat de SIMON' : 'El chat de SIMON
                                        está oculto' }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Register Tab -->
                <div *ngIf="activeTab === 'register'">
                    <h2 class="text-xl font-semibold text-gray-900 mb-6">Control de Registro de Usuarios</h2>

                    <!-- Loading State -->
                    <div *ngIf="registerLoading" class="text-center py-12">
                        <i class="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
                        <p class="text-gray-600">Cargando configuración...</p>
                    </div>

                    <!-- Register Configuration -->
                    <div *ngIf="!registerLoading" class="bg-gray-50 rounded-lg border border-gray-200 p-6">
                        <div class="flex items-center justify-between">
                            <div class="flex-1">
                                <h3 class="text-lg font-semibold text-gray-900 mb-2">
                                    <i class="fas fa-user-plus text-blue-600 mr-2"></i>
                                    Habilitar Registro de Nuevos Usuarios
                                </h3>
                                <p class="text-sm text-gray-600">
                                    Controla si los nuevos usuarios pueden registrarse en la aplicación móvil
                                </p>
                            </div>
                            <div class="ml-6">
                                <label class="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" [checked]="registerEnabled"
                                        (change)="onRegisterToggleChange($event)" [disabled]="registerToggleLoading"
                                        class="sr-only peer" />
                                    <div
                                        class="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600">
                                    </div>
                                    <span class="ml-3 text-sm font-medium" [class.text-green-600]="registerEnabled"
                                        [class.text-gray-500]="!registerEnabled">
                                        {{ registerEnabled ? 'Activado' : 'Desactivado' }}
                                    </span>
                                </label>
                            </div>
                        </div>

                        <!-- Status Indicator -->
                        <div class="mt-4 pt-4 border-t border-gray-200">
                            <div class="flex items-center">
                                <div class="flex-shrink-0">
                                    <div class="h-3 w-3 rounded-full" [class.bg-green-500]="registerEnabled"
                                        [class.bg-gray-400]="!registerEnabled"></div>
                                </div>
                                <p class="ml-3 text-sm text-gray-600">
                                    Estado actual:
                                    <span class="font-semibold" [class.text-green-600]="registerEnabled"
                                        [class.text-gray-600]="!registerEnabled">
                                        {{ registerEnabled ? 'Los usuarios pueden registrarse en la app' : 'El registro
                                        de usuarios está deshabilitado' }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Message Editor Section -->
                    <div *ngIf="!registerLoading" class="bg-white rounded-lg border border-gray-200 p-6 mt-6">
                        <div class="mb-4">
                            <h3 class="text-lg font-semibold text-gray-900 mb-2">
                                <i class="fas fa-comment-alt text-blue-600 mr-2"></i>
                                Mensaje de Registro Deshabilitado
                            </h3>
                            <div class="bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-4">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <i class="fas fa-exclamation-triangle text-yellow-400"></i>
                                    </div>
                                    <div class="ml-3">
                                        <p class="text-sm text-yellow-700">
                                            Este mensaje se mostrará a los usuarios cuando intenten registrarse y el
                                            registro esté deshabilitado.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="space-y-4">
                            <div>
                                <label class="block text-sm font-medium text-gray-700 mb-2">
                                    Mensaje
                                </label>
                                <textarea [(ngModel)]="registerMessage" rows="4"
                                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Ingrese el mensaje que verán los usuarios cuando el registro esté deshabilitado"></textarea>
                                <p class="text-xs text-gray-500 mt-1">
                                    Caracteres: {{ registerMessage.length }}
                                </p>
                            </div>

                            <div class="flex justify-end">
                                <button (click)="saveRegisterMessage()"
                                    [disabled]="registerMessageSaving || !registerMessage"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center">
                                    <i class="fas mr-2" [class.fa-spinner]="registerMessageSaving"
                                        [class.fa-spin]="registerMessageSaving"
                                        [class.fa-save]="!registerMessageSaving"></i>
                                    {{ registerMessageSaving ? 'Guardando...' : 'Guardar Mensaje' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Carrusel Tab -->
                <div *ngIf="activeTab === 'carrusel'">
                    <div class="flex justify-between items-center mb-6">
                        <h2 class="text-xl font-semibold text-gray-900">Configuración del Carrusel</h2>
                        <button (click)="openAddCarruselItemModal()"
                            class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                            <i class="fas fa-plus mr-2"></i>
                            Agregar Item
                        </button>
                    </div>

                    <!-- Loading State -->
                    <div *ngIf="carruselLoading" class="text-center py-12">
                        <i class="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
                        <p class="text-gray-600">Cargando configuración...</p>
                    </div>

                    <!-- Carrusel Global Status -->
                    <div *ngIf="!carruselLoading" class="bg-gray-50 rounded-lg border border-gray-200 p-6 mb-6">
                        <div class="flex items-center justify-between">
                            <div class="flex-1">
                                <h3 class="text-lg font-semibold text-gray-900 mb-2">
                                    <i class="fas fa-power-off text-blue-600 mr-2"></i>
                                    Estado Global del Carrusel
                                </h3>
                                <p class="text-sm text-gray-600">
                                    Controla si el carrusel se muestra en el home de la aplicación
                                </p>
                            </div>
                            <div class="ml-6">
                                <label class="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" [checked]="carruselEnabled"
                                        (change)="onCarruselToggleChange($event)" [disabled]="carruselToggleLoading"
                                        class="sr-only peer" />
                                    <div
                                        class="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600">
                                    </div>
                                    <span class="ml-3 text-sm font-medium" [class.text-green-600]="carruselEnabled"
                                        [class.text-gray-500]="!carruselEnabled">
                                        {{ carruselEnabled ? 'Activado' : 'Desactivado' }}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Carrusel Items List -->
                    <div *ngIf="!carruselLoading && carruselItems.length > 0" class="space-y-4">
                        <h3 class="text-lg font-semibold text-gray-900 mb-4">Items del Carrusel</h3>
                        <div *ngFor="let item of carruselItems"
                            class="bg-white rounded-lg border border-gray-200 p-4 hover:border-blue-300 transition-colors shadow-sm">
                            <div class="flex items-start justify-between">
                                <div class="flex items-start space-x-4">
                                    <!-- Icon Preview (if it's an image URL) -->
                                    <div
                                        class="flex-shrink-0 w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden border border-gray-200">
                                        <img *ngIf="item.icon && item.icon.includes('/')" [src]="item.icon" alt="Icon"
                                            class="w-full h-full object-contain p-2"
                                            onerror="this.style.display='none'">
                                        <i *ngIf="!item.icon || !item.icon.includes('/')"
                                            class="fas fa-image text-gray-400 text-2xl"></i>
                                    </div>

                                    <div>
                                        <div class="flex items-center space-x-2">
                                            <span
                                                class="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded">Orden:
                                                {{ item.order }}</span>
                                            <h4 class="text-lg font-medium text-gray-900">{{ item.title }}</h4>
                                        </div>
                                        <p class="text-gray-600 mt-1">{{ item.description }}</p>
                                        <div class="mt-2 text-xs text-gray-500 flex flex-col space-y-1">
                                            <span class="flex items-center">
                                                <i class="fas fa-link w-4 mr-1"></i> Icono: {{ item.icon }}
                                            </span>
                                            <span class="flex items-center" *ngIf="item.action">
                                                <i class="fas fa-bolt w-4 mr-1"></i> Acción: {{ item.action }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex items-center space-x-4 ml-4">
                                    <!-- Toggle Switch -->
                                    <label class="relative inline-flex items-center cursor-pointer"
                                        title="Activar/Desactivar Item">
                                        <input type="checkbox" [checked]="item.status"
                                            (change)="toggleCarruselItem(item, $event)" class="sr-only peer" />
                                        <div
                                            class="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
                                        </div>
                                    </label>

                                    <!-- Delete Button -->
                                    <button (click)="deleteCarruselItem(item)"
                                        class="text-red-600 hover:text-red-800 hover:bg-red-50 p-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-red-500"
                                        title="Eliminar item">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Empty State -->
                    <div *ngIf="!carruselLoading && carruselItems.length === 0"
                        class="text-center py-12 bg-white rounded-lg border border-gray-200 border-dashed">
                        <i class="fas fa-images text-6xl text-gray-300 mb-4"></i>
                        <p class="text-gray-600 text-lg mb-2">No hay items en el carrusel</p>
                        <p class="text-gray-500 text-sm">Agrega un item para mostrar en el carrusel</p>
                    </div>
                </div>

                <!-- Modal Home App Tab -->
                <div *ngIf="activeTab === 'homeModal'">
                    <h2 class="text-xl font-semibold text-gray-900 mb-6">Configuración del Modal Home App</h2>

                    <!-- Loading State -->
                    <div *ngIf="homeModalLoading" class="text-center py-12">
                        <i class="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
                        <p class="text-gray-600">Cargando configuración...</p>
                    </div>

                    <!-- Modal Home Global Status -->
                    <div *ngIf="!homeModalLoading" class="bg-gray-50 rounded-lg border border-gray-200 p-6 mb-6">
                        <div class="flex items-center justify-between">
                            <div class="flex-1">
                                <h3 class="text-lg font-semibold text-gray-900 mb-2">
                                    <i class="fas fa-power-off text-blue-600 mr-2"></i>
                                    Estado del Modal Home
                                </h3>
                                <p class="text-sm text-gray-600">
                                    Controla si el modal se muestra cuando un usuario se loguea en la aplicación móvil
                                </p>
                            </div>
                            <div class="ml-6">
                                <label class="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" [checked]="homeModalEnabled"
                                        (change)="onHomeModalToggleChange($event)" [disabled]="homeModalToggleLoading"
                                        class="sr-only peer" />
                                    <div
                                        class="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600">
                                    </div>
                                    <span class="ml-3 text-sm font-medium" [class.text-green-600]="homeModalEnabled"
                                        [class.text-gray-500]="!homeModalEnabled">
                                        {{ homeModalEnabled ? 'Activado' : 'Desactivado' }}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- HTML Editor Section -->
                    <div *ngIf="!homeModalLoading" class="bg-white rounded-lg border border-gray-200 p-6">
                        <div class="mb-4">
                            <h3 class="text-lg font-semibold text-gray-900 mb-2">
                                <i class="fas fa-code text-blue-600 mr-2"></i>
                                Contenido HTML del Modal
                            </h3>
                            <div class="bg-blue-50 border-l-4 border-blue-400 p-3 mb-4">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <i class="fas fa-info-circle text-blue-400"></i>
                                    </div>
                                    <div class="ml-3">
                                        <p class="text-sm text-blue-700">
                                            Este HTML se mostrará dentro del modal cuando un usuario inicie sesión en la app.
                                            Puedes usar tags HTML estándar para dar formato al contenido.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="space-y-4">
                            <div>
                                <label class="block text-sm font-medium text-gray-700 mb-2">
                                    Código HTML
                                </label>
                                <textarea [(ngModel)]="homeModalHtml" rows="12"
                                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-mono text-sm"
                                    placeholder="<div><p>¡Invitamos a comprar su póliza RCV con Seguros Caracas!</p></div>"></textarea>
                                <p class="text-xs text-gray-500 mt-1">
                                    Caracteres: {{ homeModalHtml.length }}
                                </p>
                            </div>

                            <div class="flex justify-end">
                                <button (click)="saveHomeModalHtml()"
                                    [disabled]="homeModalHtmlSaving"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center">
                                    <i class="fas mr-2" [class.fa-spinner]="homeModalHtmlSaving"
                                        [class.fa-spin]="homeModalHtmlSaving"
                                        [class.fa-save]="!homeModalHtmlSaving"></i>
                                    {{ homeModalHtmlSaving ? 'Guardando...' : 'Guardar HTML' }}
                                </button>
                            </div>
                        </div>

                        <!-- Preview Section -->
                        <div class="mt-6 pt-6 border-t border-gray-200" *ngIf="homeModalHtml">
                            <h4 class="text-md font-semibold text-gray-900 mb-3">
                                <i class="fas fa-eye text-gray-600 mr-2"></i>
                                Vista Previa
                            </h4>
                            <div class="bg-gray-50 border border-gray-200 rounded-lg p-4">
                                <div [innerHTML]="homeModalHtml" class="prose prose-sm max-w-none"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Add Service Modal -->
                <div *ngIf="showAddServiceModal"
                    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50"
                    (click)="closeAddServiceModal()">
                    <div class="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-lg bg-white"
                        (click)="$event.stopPropagation()">
                        <div class="flex justify-between items-center mb-4">
                            <h3 class="text-lg font-semibold text-gray-900">Agregar Nuevo Servicio</h3>
                            <button (click)="closeAddServiceModal()"
                                class="text-gray-400 hover:text-gray-600 focus:outline-none">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>

                        <form [formGroup]="addServiceForm" (ngSubmit)="submitAddService()">
                            <div class="space-y-4">
                                <!-- Code -->
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">
                                        Código <span class="text-red-500">*</span>
                                    </label>
                                    <input type="text" formControlName="code"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="ej: PAYMENT_SERVICE" />
                                </div>

                                <!-- Name -->
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">
                                        Nombre <span class="text-red-500">*</span>
                                    </label>
                                    <input type="text" formControlName="name"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="ej: Servicio de Pagos" />
                                </div>

                                <!-- Description -->
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">
                                        Descripción
                                    </label>
                                    <textarea formControlName="description" rows="3"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="Descripción del servicio"></textarea>
                                </div>

                                <div class="grid grid-cols-2 gap-4">
                                    <!-- Order -->
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Orden <span class="text-red-500">*</span>
                                        </label>
                                        <input type="number" formControlName="order" min="1"
                                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                                    </div>

                                    <!-- Parent Service -->
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Servicio Padre
                                        </label>
                                        <select formControlName="parent"
                                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                                            <option value="">Ninguno</option>
                                            <option *ngFor="let service of rootServices" [value]="service.code">
                                                {{ service.name || service.code }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="flex justify-end space-x-3 mt-6">
                                <button type="button" (click)="closeAddServiceModal()"
                                    class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400">
                                    Cancelar
                                </button>
                                <button type="submit" [disabled]="addServiceLoading || !addServiceForm.valid"
                                    class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed">
                                    <i class="fas" [class.fa-spinner]="addServiceLoading"
                                        [class.fa-spin]="addServiceLoading" [class.fa-plus]="!addServiceLoading"
                                        class="mr-2"></i>
                                    {{ addServiceLoading ? 'Agregando...' : 'Agregar Servicio' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Add Carrusel Item Modal -->
                <div *ngIf="showAddCarruselItemModal"
                    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50"
                    (click)="closeAddCarruselItemModal()">
                    <div class="relative top-20 mx-auto p-5 border w-full max-w-lg shadow-lg rounded-lg bg-white"
                        (click)="$event.stopPropagation()">
                        <div class="flex justify-between items-center mb-4">
                            <h3 class="text-lg font-semibold text-gray-900">Agregar Item al Carrusel</h3>
                            <button (click)="closeAddCarruselItemModal()"
                                class="text-gray-400 hover:text-gray-600 focus:outline-none">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>

                        <form [formGroup]="addCarruselItemForm" (ngSubmit)="submitAddCarruselItem()">
                            <div class="space-y-4">
                                <!-- Title -->
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">
                                        Título <span class="text-red-500">*</span>
                                    </label>
                                    <input type="text" formControlName="title"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="ej: Compra un seguro" />
                                </div>

                                <!-- Description -->
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">
                                        Descripción <span class="text-red-500">*</span>
                                    </label>
                                    <textarea formControlName="description" rows="2"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="ej: ¡Págalo ya! Y recibe el respaldo que necesitas."></textarea>
                                </div>

                                <!-- Icon -->
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">
                                        Icono (Ruta o URL) <span class="text-red-500">*</span>
                                    </label>
                                    <input type="text" formControlName="icon"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="ej: assets/images/insurance/seguros.svg" />
                                    <p class="text-xs text-gray-500 mt-1">Ruta local o URL de la imagen</p>
                                </div>

                                <div class="grid grid-cols-2 gap-4">
                                    <!-- Order -->
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Orden <span class="text-red-500">*</span>
                                        </label>
                                        <input type="number" formControlName="order" min="1"
                                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                                    </div>

                                    <!-- Action -->
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Acción (Opcional)
                                        </label>
                                        <input type="text" formControlName="action"
                                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            placeholder="ej: /insurance" />
                                    </div>
                                </div>

                                <!-- Status -->
                                <div class="flex items-center mt-2">
                                    <input type="checkbox" formControlName="status" id="itemStatus"
                                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                                    <label for="itemStatus" class="ml-2 block text-sm text-gray-900">
                                        Activo inmediatamente
                                    </label>
                                </div>
                            </div>

                            <div class="flex justify-end space-x-3 mt-6">
                                <button type="button" (click)="closeAddCarruselItemModal()"
                                    class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400">
                                    Cancelar
                                </button>
                                <button type="submit" [disabled]="addCarruselItemLoading || !addCarruselItemForm.valid"
                                    class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed">
                                    <i class="fas" [class.fa-spinner]="addCarruselItemLoading"
                                        [class.fa-spin]="addCarruselItemLoading"
                                        [class.fa-plus]="!addCarruselItemLoading" class="mr-2"></i>
                                    {{ addCarruselItemLoading ? 'Agregando...' : 'Agregar Item' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>